import React from "react";

import { Provider } from "react-redux";
import { Switch, Route, Redirect as _Redirect, useRouteMatch, Redirect } from "react-router-dom";
import { useGetApplicationQuery } from "RegisterBenAdmin/api";

import PartnerProvider from "Common/PartnerProvider";
import { useSiteConfig } from "Common/Redux/siteConfig";
import ScrollToTop from "Common/ScrollToTop";

import LoadingPage from "./components/LoadingPage";
import { LandingPage, PaymentPage, AdditionalInformationPage, DonePage } from "./pages";
import { createStore } from "./redux";
import { startURL, paymentURL, additionalInformationURL, doneURL, nextPageURL } from "./urls";

const AppPagesDumb = () => {
  const match = useRouteMatch();
  const { data: { benAdminLead } = {}, isLoading: isLoadingBenAdminLead } = useGetApplicationQuery();
  const { isLoading: isLoadingSiteConfig, data: _siteConfig } = useSiteConfig();
  return isLoadingSiteConfig || isLoadingBenAdminLead ? (
    <LoadingPage />
  ) : (
    <ScrollToTop>
      <Switch>
        <Route exact path={`${match.url}/`} children={() => <Redirect to={nextPageURL(benAdminLead)} />} />
        <Route path={startURL} children={<LandingPage />} />
        <Route path={paymentURL} children={<PaymentPage />} />
        <Route path={additionalInformationURL} children={<AdditionalInformationPage />} />
        <Route path={doneURL} children={<DonePage />} />
      </Switch>
    </ScrollToTop>
  );
};

const App = () => {
  const store = createStore({});

  return (
    <Provider store={store}>
      <PartnerProvider>
        <AppPagesDumb />
      </PartnerProvider>
    </Provider>
  );
};

export default App;
